var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-12 text-center font-weight-bold"},[_vm._v("You do not have access to this page.")])}
var staticRenderFns = []

export { render, staticRenderFns }